import type { ArticuloFabricacion } from "../../hooks/Api/Articulos.js";
import { useRef } from "react";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "./BaseModal.js";
import { ComunicacionAjax } from "@/ts/api/comunicacion.js";
import { Loading, QueryError } from "../Loading/Loading.js";
import { notificacionTipo } from "../Alerts.js";
import { ImputacionForm, type ImputacionFormData } from "../ImputacionForm.js";
import { useArticuloKit, type ArticuloKit } from "@/hooks/Api/KitsFabricacion.js";

interface ModalCrearOFProps extends BaseModalProps {
	readonly data: ArticuloFabricacion[] | null;
	readonly articulo: ArticuloFabricacion | null;
}
export function ModalCrearInputacion(props: ModalCrearOFProps) {
	const queryArticulo = useArticuloKit(props.articulo?.idArticulo ?? null);

	if (queryArticulo.error) return <QueryError error={queryArticulo.error} fallback="Error al cargar los kits" />;

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Orden de Fabricación</h4>
				<ModalCloseCross onClick={props.close} />
			</div>

			{(props.articulo !== null && props.data !== null && queryArticulo.isSuccess) ? (
				<ModalContent articulo={props.articulo} articuloKit={queryArticulo.data} close={props.close} />
			) : (
				<Loading />
			)}
		</BaseModal >
	);
}

function ModalContent(props: { readonly articulo: ArticuloFabricacion, readonly articuloKit: ArticuloKit, readonly close: () => void; }) {
	const cantidadInicial = props.articulo.entrarRecomendado > 0 ? props.articulo.entrarRecomendado : 1;
	const formRef = useRef<{ handleSubmit: () => void; }>(null);

	const initialValues: ImputacionFormData = {
		cantidad: cantidadInicial,
		lote: "",
		notas: "",
		idSeccion: "",
		fecha: new Date().toISOString().split("T")[0],
		consumos: props.articuloKit.componentes ? props.articuloKit.componentes.map(comp => ({
			idComponente: comp.idComponente,
			refComponente: comp.refComponente,
			descComponente: comp.descComponente,
			cantidadPorUnidad: comp.cantidadPorUnidad,
			cantidadDivisor: comp.cantidadDivisor,

			lote: "",
			cantidadDefectuosa: 0,
			cantidadDesperdiciada: 0,
		})) : [],
	};
	const onSubmit = async (data: ImputacionFormData) => {
		const success = await lanzarImputacion(props.articuloKit.idArticulo, data);
		if (success) {
			props.close();
		}
	};


	return <>
		<div className="modal-body" style={{ minWidth: "60vw" }}>
			<div style={{ marginBottom: 20 }}>
				<h2 style={{ margin: 0 }}>
					<span>Conjunto: </span>
					<span style={{ color: "#666666", fontWeight: "bold" }} >
						{props.articulo.nombreArticulo} ({props.articulo.referencia})
					</span>
				</h2>
			</div>

			<ImputacionForm
				ref={formRef}
				articuloKit={props.articuloKit}
				initialValues={initialValues}
				onSubmit={(data) => void onSubmit(data)}
			/>
		</div>
		<div className="modal-footer">
			<button type="button" className="btnSecondary" style={{ float: "left" }} onClick={props.close}>Cerrar</button>
			<button type="button" className="btnPrimary" onClick={() => formRef.current?.handleSubmit()}>Crear Imputación</button>
		</div>
	</>;
}




async function lanzarImputacion(id_articulo: number, values: ImputacionFormData): Promise<boolean> {
	const consumos = values.consumos.map(comp => ({
		idArticulo: comp.idComponente,
		refArticulo: comp.refComponente,
		descArticulo: comp.descComponente,
		loteArticulo: comp.lote,
		cantidadPorUnidad: comp.cantidadPorUnidad,
		cantidadDivisor: comp.cantidadDivisor,
		cantidadDefectuosa: comp.cantidadDefectuosa,
		cantidadDesperdiciada: comp.cantidadDesperdiciada,
	}));

	const parametro = {
		articuloProducido: id_articulo,
		cantidadProducida: values.cantidad,
		tsUnico: Math.trunc(new Date(values.fecha).getTime() / 1000),
		notas: values.notas,
		lote: values.lote,
		idSeccion: values.idSeccion,
		consumos: consumos,
	};

	const url = "/api/v1/imputarArticulo";
	const response = await ComunicacionAjax.sendAjaxRequest<{ status: "exito" | "error", message?: string; }>("POST", url, parametro);
	if (response.status == "error") {
		notificacionTipo("error", response.message ?? "Error lanzando Imputación");
		return false;
	}

	notificacionTipo("success", response.message ?? "Imputación lanzada correctamente");
	return true;
}